import { useState } from "react";
import firebaseService from "firebase_service/firebaseService";
import { useTheme } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import DSBox from "views/system-design/DSBox";
import DSStack from "views/system-design/DSStack";
import DSTextField from "views/system-design/DSTextField";
import DSTypography from "views/system-design/DSTypography";
import DSPrimaryButton from "views/system-design/DSPrimaryButton";
import DSSecondaryButton from "views/system-design/DSSecondaryButton";
import logo from "assets/img/Klydoclock_logo.svg";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({ email: "", password: "" });
  const { palette } = useTheme();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.stopPropagation();
      return;
    }
    firebaseService
      .loginWithEmail({ email: email, password: password })
      .catch((e) => setError(e));
  };

  return (
    <DSBox
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: palette.background.default,
        p: 2,
      }}
    >
      <form
        noValidate
        onSubmit={handleSubmit}
        style={{ width: "100%", maxWidth: 420 }}
      >
        <DSBox
          sx={{
            width: "100%",
            background: palette.surface.cardGradient,
            border: `1px solid ${palette.surface.border}`,
            borderRadius: "28px",
            boxShadow:
              "0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)",
            p: { xxs: 3, sm: 5 },
          }}
        >
          <DSStack spacing={3} alignItems="stretch">
            <DSBox sx={{ display: "flex", justifyContent: "center", py: 1 }}>
              <img src={logo} alt="Klydo" width={200} height="auto" />
            </DSBox>
            <DSTypography variant="h5" textAlign="center">
              Backoffice Login
            </DSTypography>
            <DSTextField
              label="Email address"
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={error.email !== ""}
              helperText={error.email}
              required
              fullWidth
            />
            <DSTextField
              label="Password"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={error.password !== ""}
              helperText={error.password}
              required
              fullWidth
            />
            <DSPrimaryButton type="submit" size="large" fullWidth>
              Login
            </DSPrimaryButton>
            <DSTypography variant="body2" textAlign="center">
              Or
            </DSTypography>
            <DSSecondaryButton
              startIcon={<GoogleIcon />}
              fullWidth
              onClick={() => {
                firebaseService.loginSocial("google").catch((e) => setError(e));
              }}
            >
              Continue with Google
            </DSSecondaryButton>
            <DSSecondaryButton
              startIcon={<FacebookIcon />}
              fullWidth
              onClick={() => {
                firebaseService
                  .loginSocial("facebook")
                  .catch((e) => setError(e));
              }}
            >
              Continue with Facebook
            </DSSecondaryButton>
          </DSStack>
        </DSBox>
      </form>
    </DSBox>
  );
}

export default Login;
